// Generated by purs version 0.14.3
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Data_Functor_Tagged = require("../Data.Functor.Tagged/index.js");
var Record = require("../Record/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var UncurryFields = function (uncurryFields) {
    this.uncurryFields = uncurryFields;
};
var uncurryFieldsEmpty = new UncurryFields(function (v) {
    return Control_Category.identity(Control_Category.categoryFn);
});
var uncurryFields = function (dict) {
    return dict.uncurryFields;
};
var uncurryFieldsInductive = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictLacks) {
            return function (dictUncurryFields) {
                return new UncurryFields(function (r) {
                    return function (f) {
                        var before = Record["delete"](dictIsSymbol)()()(Type_Proxy["Proxy"].value)(r);
                        var arg = Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r);
                        var partiallyApplied = f(Data_Functor_Tagged.tagged(arg));
                        return uncurryFields(dictUncurryFields)(before)(partiallyApplied);
                    };
                });
            };
        };
    };
};
module.exports = {
    UncurryFields: UncurryFields,
    uncurryFields: uncurryFields,
    uncurryFieldsEmpty: uncurryFieldsEmpty,
    uncurryFieldsInductive: uncurryFieldsInductive
};
